module.exports = __webpack_public_path__ + "img/service-icon-3.b4140daa.png";